import type { ThreadRow } from "../thread-design-system";

/** Stable display key shared by the V4 row widgets and lightweight consumers. */
export function rowKey(row: ThreadRow): string {
  return row.runId || String(row.id || row.conditionKey || "row");
}

/** Compact table formatting that does not pull the V4 widget dependency graph. */
export function formatValue(value: unknown): string {
  if (value == null || value === "") return "—";
  if (typeof value === "number") return Number.isInteger(value) ? String(value) : Number(value).toPrecision(4);
  if (typeof value === "string") return value;
  return JSON.stringify(value);
}
